import uploader from '@pt/store/assets/uploader'
import resource from '@pt/store/assets/resource'

export default {
  namespaced: true,
  modules: {
    uploader,
    resource,
  },
}
